/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { EMapTypeId, IIndexableObject, ILatLng, IReplayLayout, Position } from '../../models';

export enum EMapAnimationState {
  default = 'default',
  fullscreen = 'fullscreen',
  overlayHidden = 'overlayHidden',
  replayPanelClosed = 'replayPanelClosed',
  replayPanelOpen = 'replayPanelOpen'
}

export interface ILayoutState {
  isFullscreen: boolean;
  isMapFitted: boolean;
  triggerFitToMap: Object;
  locationToZoom: ILatLng;
  zoomToLocationAddress: string | null;
  locationToMove: ILatLng;
  locationToMoveWithOffset: ILatLng;
  mapType: EMapTypeId;
  locationToMarker: ILatLng;
  locationToMarkerId: number;
  locationToMoveMarker: ILatLng;
  locationToMoveMarkerId: number;
  replayLayout: IReplayLayout;
  animationState: EMapAnimationState;
  isAppAnimationsEnabled: boolean;
  overlayMargins: IIndexableObject<Position>;
  locationToPanAndZoom: ILatLng;
  isManagePostedSpeedOpen: boolean;
}

export const initialLayoutState: ILayoutState = {
  isFullscreen: false,
  isMapFitted: true,
  triggerFitToMap: undefined,
  locationToZoom: null,
  zoomToLocationAddress: null,
  locationToMove: null,
  locationToMoveWithOffset: null,
  locationToMarker: null,
  locationToMarkerId: null,
  locationToMoveMarker: null,
  locationToMoveMarkerId: null,
  mapType: EMapTypeId.ROADMAP,
  replayLayout: {
    isReplayOpen: false,
    isReplayDatePickerOpen: false,
    viewReplayParams: null
  },
  animationState: EMapAnimationState.default,
  isAppAnimationsEnabled: true,
  overlayMargins: {},
  locationToPanAndZoom: null,
  isManagePostedSpeedOpen: false
};
